import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export type DashboardColorKey = 'projects' | 'assignedToMe' | 'overtime' | 'overdue' | 'dueSoon';

export interface DashboardColorItem {
  key: string;
  name: string;
  color: string;
  displayOrder: number;
}

export interface DashboardColorsData {
  items: DashboardColorItem[];
  colors: Record<string, string>;
}

export function useDashboardColors() {
  return useQuery<DashboardColorsData>({
    queryKey: ['dashboard-colors'],
    queryFn: async () => {
      const response = await apiClient.getDashboardColors();
      if (!response.success) {
        throw new Error((response as any).message ?? 'Failed to fetch dashboard colors');
      }
      return response.data ?? { items: [], colors: {} };
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 2 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
